import nudgeStore from '../store/Store';

export function getNudgedRowKeyFromConversationId(conversationId: string): string {
    const nudgedRow = nudgeStore.nudgedRows.filter(
        nudgedRow => nudgedRow.conversationId === conversationId
    );

    // multiple items may be nudged in the same conversation
    return nudgedRow.length > 0 ? nudgedRow[0].rowKey : null;
}

export function getNudgedRowKeyFromItemId(itemId: string): string {
    const nudgedRow = nudgeStore.nudgedRows.filter(nudgedRow => nudgedRow.itemId === itemId);

    // multiple items may be nudged in the same conversation
    return nudgedRow.length > 0 ? nudgedRow[0].rowKey : null;
}
